/**
 * API Văn bản tố tụng – POC dùng mock; triển khai thật dùng cùng endpoint với backend.
 */
import { apiSlice } from './apiSlice'
import type { Document, DocumentDraftRequest } from '../../types/document'

export const documentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentsByCase: builder.query<Document[], string>({
      query: (caseId) => ({ url: `documents?case_id=${encodeURIComponent(caseId)}`, method: 'GET' }),
      providesTags: (_result, _err, caseId) => ['Documents', { type: 'Case', id: caseId }],
    }),
    createDraft: builder.mutation<Document, DocumentDraftRequest>({
      query: (body) => ({ url: 'documents/draft', method: 'POST', body }),
      invalidatesTags: ['Documents'],
    }),
  }),
})

export const { useGetDocumentsByCaseQuery, useCreateDraftMutation } = documentsApi
